import React, { Component } from 'react';
import DataCaptureService from "@services/DataCaptureService";
import SurveyService from "@services/SurveyService";
import ProfileManagementService from "@services/ProfileManagementService";
import UserProfileCard from "../../components/UserProfileCard";
import OrganisationProfileCard from "../../components/OrganisationProfileCard";
import Chip from '@mui/material/Chip';
import LinearProgress from '@mui/material/LinearProgress';
import avatar from '../../pages/Profile/faces/face-0.jpg';
import companyLogo from '../../pages/Profile/faces/company.png';
import {
  Person
} from "@mui/icons-material";
import styles from './profile.module.css';

class ResearcherProfile extends Component {
  state = {
    payload: null,
    personalData: {
      avatar: avatar,
      realmUser: null
    },
    organisationData: {
      avatar: companyLogo,
      organisationType: null,
      organisationStatus: null,
      organisationInfo: null
    },
  };

  constructor() {
    super();

    function parseJwt(token) {
      const base64Payload = token.split('.')[1];
      const payload = atob(base64Payload);
      return JSON.parse(payload.toString());
    }

    let bearer = localStorage.getItem('Bearer');
    if (!bearer) {
      window.location = "/login";

    }

    let payload = parseJwt(bearer);
    this.state.payload = payload;
  }


  async componentDidMount() {

    let myRealmUser = null;
    try {
      const realmUser = await ProfileManagementService.getUserByUsername(this.state.payload.preferred_username);
      const personalData = this.state.personalData;
      personalData.realmUser = realmUser;
      myRealmUser = realmUser;
      this.setState({ personalData: personalData });
    } catch (ex) {
      console.log('Network error loading respondent user');
    }
    
    if (myRealmUser !== undefined && myRealmUser !== null) {
      let orgData = this.state.organisationData
      try {
        await (async () => {
          const organisation = await ProfileManagementService.getOrganisationById(myRealmUser.attributes.org_id);
          orgData.organisationInfo = organisation;
        })([]);
      } catch (ex) {
        console.log('Network error loading organisation data', ex);
      }
      
      const thisOrganisationStatus = await (async () => {
        const organisationStatus = await DataCaptureService.getOrganisationStatusBySurveyCycleIdAndOrganisationId(process.env.REACT_APP_CURRENT_SURVEY_CYCLE, myRealmUser.attributes.org_id);
        orgData.organisationStatus = organisationStatus;
        return organisationStatus;
      })([]);
      
      if (thisOrganisationStatus !== undefined && thisOrganisationStatus !== null) {
        const sector = await SurveyService.getSectorById(thisOrganisationStatus.sectorId);
        if (sector != null) {
          orgData.organisationType = '' + sector.name;
        }
      }
      this.setState({ organisationData: orgData });

    }
    
  }

  render() {
    return (
      <div className={styles.container_profile}>
        <div className={styles.breadcrumbs}>
          <Chip variant='outlined' icon={<Person />}
            label="My Profile"
          />
        </div>
        {(this.state.personalData.realmUser !== undefined && this.state.personalData.realmUser !== null && this.state.organisationData !== null)
          ? <div className={styles.profile_content}>
            <UserProfileCard userData={this.state.personalData} />
            <OrganisationProfileCard organisationData={this.state.organisationData} />
          </div>
          : <div className={styles.profile_progress}>
            <LinearProgress variant='indeterminate' />
          </div>}
      </div>
    )
  }
}

export default ResearcherProfile


